<template>
  <div class="month-calender">
    <p class="title">
      <el-date-picker
        size="mini"
        style="width: 120px"
        v-model="year"
        type="year"
        @change="handleChangeYear"
        placeholder="选择年">
      </el-date-picker>
      年
    </p>
    <p class="status">
      <span class="blue">待完成<span class="block"></span></span>
      <span class="green">已完成<span class="block"></span></span>
      <span class="red">漏检<span class="block"></span></span>
    </p>
    <div class="month-content">
      <div class="month" v-for="month in dateList" :key='month.index'>
        <p class="name">
          <span class="index">
            {{(month.index + 1)}}
          </span>
          月
        </p>
        <div class="count-content" v-for="item in yearData" :key="item.date">
          <div class="count" v-if="item.date === month.date">
            <p v-for="list in item.dataList" :key="(item.date + list.type)">
              <el-popover
                placement="top-start"
                width="800"
                trigger="hover">
                <span slot="reference" :class="['type-count', `type${list.type}`]" v-if="list.planVoList.length !== 0" >
                  {{ list.planVoList.length }}
                </span>
                <el-table :data="list.planVoList" style="width: 100%" height="400px"
                  header-cell-class-name='table-header-cell' cell-class-name='table-cell'
                  border stripe fit  highlight-current-row
                  >
                  <el-table-column prop="name" label="计划名称" min-width="280" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="type" label="类型" min-width="100" :formatter="handleTypeFormat" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="status" label="状态" min-width="100" :formatter="handleStatusFormat" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="time" label="计划起止时间" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{$moment(scope.row.startTime).format('YYYY/MM/DD')}}~{{$moment(scope.row.endTime).format('YYYY/MM/DD')}}
                    </template>
                  </el-table-column>
                </el-table>
              </el-popover>
            </p>
          </div>
        </div>
        <!-- <p>{{month.date}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    yearData: Array
  },
  data() {
    return {
      year: this.$moment(new Date()).format('YYYY'),
      dateList: [],
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      statusList: [
        { label: '漏检', value: 0 },
        { label: '待完成', value: 1 },
        { label: '已完成', value: 2 }
      ],
    }
  },
  created () {
    for (let i = 0; i < 12; i++) {
      this.dateList.push({
        index: i,
        date: this.$moment().month(i).format('YYYY/MM')
      })
    }
    console.log(this.dateList)
  },
  methods: {
    handleTypeFormat (row, column, cellValue, index) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleStatusFormat (row, column, cellValue, index) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleChangeYear (val) {
      const currentYear = this.$moment(val).startOf('year').format('YYYY/MM/DD')
      this.$emit('handleChangeYear', currentYear)
    }
  }
}
</script>

<style lang="scss" scoped>
.month-calender {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .title {
    float: left;
    padding: 0 8px;
    font-size: 18px;
    color: #333;
    // text-align: center;
  }
}

.month-content {
  margin-top: 12px;
  display: flex;
  width: 100%;
  height: calc(100% - 100px);
  flex-wrap: wrap;
  .month {
    margin: 6px;
    padding: 12px;
    width: calc(25% - 12px);
    height: 33%;
    box-sizing: border-box;
    border: 1px solid #ddd;
    .name {
      font-size: 16px;
      // text-align: center;
      .index {
        font-weight: bold;
      }
    }
  }
}


.status {
  float: right;
}

.blue {
  margin: 0 0 0 24px;
  padding: 3px;
  background: #fff;
  border-bottom: 1px solid #409EFF;
  border-right: 12px solid #409EFF;
}

.green {
  padding: 3px;
  margin: 0 0 0 24px;
  background: #fff;
  border-bottom: 1px solid #67C23A;
  border-right: 12px solid #67C23A;
}

.red {
  padding: 3px;
  margin: 0 6px 0 24px;
  background: #fff;
  border-bottom: 1px solid #F56C6C;
  border-right: 12px solid #F56C6C;
}

.count > p {
  margin: 12px 0;
}

.type-count {
  margin-top: 12px;
  padding: 3px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  box-sizing: border-box;
}

.type0 {
  margin-right: 8px;
  color: #333;
  border-bottom: 1px solid #F56C6C;
  border-right: 6px solid #F56C6C;
}

.type1 {
  margin-right: 8px;
  color: #333;
  border-bottom: 1px solid #409EFF;
  border-right: 6px solid #409EFF;
}

.type2 {
  color: #333;
  border-bottom: 1px solid #67C23A;
  border-right: 6px solid #67C23A;
}
</style>
